// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8f922be5","455":"9937a2b8","977":"820cfd40"}[chunkId] + ".chunk.js";
};